import { render, staticRenderFns } from "./popup_imagen.vue?vue&type=template&id=504c1f51&"
import script from "./popup_imagen.vue?vue&type=script&lang=js&"
export * from "./popup_imagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports